/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScenarioHistoryItem
 */
export interface InternalApiScenarioHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioHistoryItem
     */
    action: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioHistoryItem
     */
    time?: Date;
}

/**
 * Check if a given object implements the InternalApiScenarioHistoryItem interface.
 */
export function instanceOfInternalApiScenarioHistoryItem(value: object): value is InternalApiScenarioHistoryItem {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function InternalApiScenarioHistoryItemFromJSON(json: any): InternalApiScenarioHistoryItem {
    return InternalApiScenarioHistoryItemFromJSONTyped(json, false);
}

export function InternalApiScenarioHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'time': json['time'] == null ? undefined : (new Date(json['time'])),
    };
}

export function InternalApiScenarioHistoryItemToJSON(json: any): InternalApiScenarioHistoryItem {
    return InternalApiScenarioHistoryItemToJSONTyped(json, false);
}

export function InternalApiScenarioHistoryItemToJSONTyped(value?: InternalApiScenarioHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'time': value['time'] == null ? value['time'] : value['time'].toISOString(),
    };
}

